module.exports = __webpack_public_path__ + "img/text-con-5.4551a8ee.png";